import React, { useState, useCallback } from 'react';
import { connect } from 'react-redux';
import { Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import sharedStyles from './styles/shared-components.module.css';
import styles from './styles/select-input.module.css';
import { addAnswer } from '@/store/slices/chatbotFlow';

const SelectInput = ({ block, addAnswer }) => {
  const [input, setInput] = useState('');
  const [options, setOptions] = useState([]);

  const onSearch = useCallback((e) => {
    const searchText = e.target.value;
    setInput(searchText);
    const filteredOptions = searchText.length === 0
      ? []
      : block?.options?.answers?.filter(option =>
        option.title.toLowerCase().includes(searchText.toLowerCase())
      );
    setOptions(filteredOptions);
  }, [block]);

  const renderOptions = () => {
    return options.map((option, i) => (
      <p
        key={i}
        onClick={() => addAnswer(option.title)}
        className={styles.option}
      >
        {option.title}
      </p>
    ));
  };

  return (
    <div className={sharedStyles.wrapper}>
      { options.length > 0 && <div
        className={`${styles.options_container}`}>
        {renderOptions()}
      </div>}
      <div className={styles.inputContainer}>
        <Input variant={"borderless"}
          className={styles.input}
          value={input}
          autoFocus
          prefix={<SearchOutlined className={styles.icon_prefix} />}
          placeholder="Search..."
          onChange={onSearch}
        />
      </div>
    </div>
  );
};

SelectInput.propTypes = {
  block: PropTypes.object,
  addAnswer: PropTypes.func.isRequired,
};

const mapDispatchToProps = { addAnswer };

export default connect(null, mapDispatchToProps)(SelectInput);
